import { Modal, Button } from "antd";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { banPassengerByIdApi } from "api/passenger";
import WarningIcon from "components/Icons/WarningIcon";
import { useNotificationContext } from "contexts/NotificationContext";
import { IBanPassenger, IUser } from "models/user";
import { useState } from "react";
import LabeledInput from "components/Form/LabeledInput";
import { useForm } from "react-hook-form";
import banPassengerValidator from "validators/banPassenger.validator";
import { yupResolver } from "@hookform/resolvers/yup";

interface IProp {
  open: boolean;
  passenger: IUser;
  handleClose: () => void;
}

export default function BanModal({ open, passenger, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadPassengers } = useDataLoadingContext();
  const { control, handleSubmit } = useForm<IBanPassenger>({
    resolver: yupResolver(banPassengerValidator),
  });

  const onSubmit = async (input: IBanPassenger) => {
    setLoading(true);
    const { data, error } = await banPassengerByIdApi(passenger.id, input);
    if (data) {
      showSuccess("Passenger banned successfully");
      loadPassengers();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
            <WarningIcon />
          </div>
          <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
          <p
            className="font-normal text-base"
            style={{ color: "rgba(0,0,0,.64)" }}
          >
            You're about to ban {passenger.first_name} {passenger.last_name}
          </p>
          <div className="w-full mt-2 text-start">
            <LabeledInput
              name="reason"
              type="text"
              label="Reason for banning"
              placeholder="Enter reason"
              control={control}
            />
          </div>
          <div className="w-full flex mt-7 items-center justify-end gap-x-3">
            <Button onClick={handleClose}>Cancel</Button>
            <Button loading={loading} type="primary" danger htmlType="submit">
              Ban
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
